import { render } from "./StatisticByBarriers.vue?vue&type=template&id=3e8925ae&scoped=true"
import script from "./StatisticByBarriers.vue?vue&type=script&lang=js"
export * from "./StatisticByBarriers.vue?vue&type=script&lang=js"

import "./StatisticByBarriers.vue?vue&type=style&index=0&id=3e8925ae&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8925ae"]])

export default __exports__